<template>
  <header
    :class="containerClass"
    class="page-header"
  >
    <MainNavigation
      v-if="hasNav"
      :hide-navi="hideNavi"
    />
    <DialogContainer :with-nav="hasNav" />
  </header>
</template>

<script>
import DialogContainer from '~/components/flyout-container.vue';
import MainNavigation from '~/components/navigation/main-navigation.vue';

export default {
  name: 'PageHeader',
  components: {
    DialogContainer,
    MainNavigation,
  },
  props: {
    theme: {
      type: String,
      default: null,
    },
    hideNavi: { type: Boolean },
  },
  data() {
    return {
      brandingHeight: null,
    };
  },
  computed: {
    containerClass() {
      return {
        [`page-header--${this.theme}`]: !!this.theme,
      };
    },
    hasNav() {
      return !this.theme;
    },
  },
  mounted() {
    const { branding } = this.$refs;
    if (branding) {
      this.brandingHeight = branding.$el.clientHeight;
    }
  },
};
</script>

<style lang="scss" scoped>
@use 'assets/base' as *;

.page-header {
  position: sticky;
  top: 0;
  z-index: $z-index-header;
  transition: top 0.4s $nav-timing-function;
  // set "flex" to avoid space for the dialog
  display: flex;
  flex-direction: column;

  &--small {
    border-top: 4px solid var(--color-primary);
    @include mq($mq-lg) {
      top: 0;
    }
  }
}

body.nav-scrolled {
  .page-header {
    @include mq($mq-lg) {
      top: $nav-shrink-offset * -1;
    }
  }
}
</style>
